import { Redirect } from 'react-router-dom'; // Import Redirect for navigation
import { useAuthValue } from '../src/AuthContext'; // Import custom hook to access authentication context
import React from 'react';

// PrivateRoute component for protecting routes based on authentication status
export default function PrivateRoute({ children }) {
  const { currentUser } = useAuthValue(); // Get current user from authentication context

  // If no valid authentication token, redirect to login page
  if (!currentUser?.getIdToken()) {
    return <Redirect to='/login' replace />;
  }

  // If authenticated, render the child components
  return children;
}
